import type { ReactElement } from "react";
import { Snackbar, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const DEFAULT_AUTO_HIDE_DURATION = 5000;
interface SimpleNotificationToastProps {
  message?: string;
  showToast: boolean;
  autoHideDuration?: number;
  onClose: () => void;
}

const SimpleNotificationToast = ({
  message,
  showToast,
  autoHideDuration,
  onClose,
}: SimpleNotificationToastProps): ReactElement => {
  const action = (
    <>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={onClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </>
  );

  return (
    <Snackbar
      open={showToast}
      autoHideDuration={autoHideDuration ?? DEFAULT_AUTO_HIDE_DURATION}
      onClose={onClose}
      message={message}
      action={action}
    />
  );
};

export default SimpleNotificationToast;
